module.exports={
  "sounds": {
    "spin": "sounds/spin.mp3",
    "spin-stop": "sounds/spin-stop.mp3",
    "bonus-spins": "sounds/bonus-spins.mp3",
    "bonus-win": "sounds/bonus-win.mp3",
    "touch": "sounds/touch.mp3",
    "wild-scatter": "sounds/wild-scatter.mp3",
    "win": "sounds/win.mp3",
    "win-extra": "sounds/win-extra.mp3"
  },

  "music": {
    "bg-music": "music/bg-music.mp3",
    "bonus-round-music": "music/bonus-round-music.mp3"
  }
}